import React          from 'react';
import PropTypes      from 'prop-types'
import RadioComponent from './base/RadioComponent';
import ErrorLabel     from './base/ErrorLabel';

const Panelized = (props) => {
  const name = 'is_panelized';
  const onChange = e => props.onChangeParameter(name, e.target.value);
  return (
    <div className="panelized">
      <span>
        Are your Gerbers already Stepped and Repeated (Panelized)?
      </span>
      <div className="row">
        <div className="col-6">
          <RadioComponent
            name={name}
            label="Yes"
            value="1"
            checked={props.parameters[name] === '1'}
            onChange={props.onChange || onChange}
            inputId="panelized-yes"
            groupName={props.groupName}
            prefix_name={props.prefix_name} />
        </div>
        <div className="col-6">
          <RadioComponent
            name={name}
            label="No"
            value="0"
            checked={props.parameters[name] === '0'}
            onChange={props.onChange || onChange}
            inputId="panelized-no"
            groupName={props.groupName}
            prefix_name={props.prefix_name} />
        </div>
      </div>
      <ErrorLabel error={props.errors.isPanelized} />
    </div>
  );
};

Panelized.propTypes = {
  parameters: PropTypes.object.isRequired,
  onChangeParameter: PropTypes.func.isRequired,
};



export default Panelized;
